// React and related imports
import React from 'react';

// i18 hooks
import { useTranslation } from 'react-i18next';

// Custom Components
import { TableHead } from '../Table/Table';

interface ContentTableHeadProps {
  sortingHandler: (fieldId: string) => void;
}

export const ContentTableHead: React.FC<ContentTableHeadProps> = ({
  sortingHandler,
}) => {
  const { t } = useTranslation();

  const columnHeadLabels = [
    { id: 'title', label: t('content.title'), sortable: true },
    { id: 'type', label: t('content.type') },
    { id: 'mediaUrl', label: t('content.mediaUrl') },
    { id: 'updatedAt', label: t('contentContext.updatedAt'), sortable: true },
    { id: 'edit', label: t('content.edit') },
  ];

  return (
    <TableHead
      columns={columnHeadLabels}
      onClick={sortingHandler}
      withSortingIcon
    />
  );
};
